import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import illustration from "Assets/Svg/chilling.svg";
import { withSnackbar } from "notistack";
import React from "react";
import get from "lodash/get";
import moment from "moment";
import { connect } from "react-redux";
import Chip from "@material-ui/core/Chip";
import { bindActionCreators } from "redux";
import { getFormattedImageLink } from "Utils";
import { instance } from "../../../Actions/AxiosInstance";
import { getFormattedDate, getFormattedTimeFromDate } from "../../../Utils";
import { backToHome } from "../../../Handlers/setters";

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
  table: {
    width: "100%",
  },
  TableCell: {
    padding: "14px 16px 14px 16px",
    borderBottom: "none",
  },
  TableRow: {
    borderRadius: 4,
  },
});

const getRequestType = (request) => {
  if (request) {
    if (request.requestmoduleid == 2) {
      if (request.requesttypeid == 1) {
        return "punch logs";
      } else if (request.requesttypeid == 2) {
        return request.requesteddata.workrequesttypename;
      } else if (request.requesttypeid == 3) {
        return "attendance";
      } else if (request.requesttypeid == 4) {
        return request.requesteddata.workrequesttypename;
      } else if (request.requesttypeid == 8) {
        return "extra time";
      }
    } else if (request.requestmoduleid == 4) {
      if (request.requesttypeid == 1) {
        return `${request.requesteddata.leavetypename}`;
      } else if (request.requesttypeid == 2) {
        return "to update their optional holidays";
      }
    } else if (request.requestmoduleid == 5) {
      if (request.requesttypeid == 1) {
        return "expense claim";
      } else if (request.requesttypeid == 2) {
        return "advance expense";
      }
    }
  }
  return "";
};

const getTime = (timeString) => {
  const H = +timeString.substr(0, 2);
  const h = H % 12 || 12;
  const ampm = H < 12 || H === 24 ? "AM" : "PM";
  return h + timeString.substr(2, 3) + ampm;
};

class DialyRequest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      actionid: null,
      requestDetail: {},
      imagepath: "",
      workfromhome: true,
      clockin: true,
      claimExpense: false,
      advanceExpense: false,
      regularise: false,
      punchlogs: false,
      leave: false,
      optionalHoliday: false,
      time: 10,
      error: null,
    };

    this.interval = null;

    this.closeWindow = this.closeWindow.bind(this);
    this.revokeAction = this.revokeAction.bind(this);
  }

  componentDidMount() {
    localStorage.removeItem("prevLink");
    const { params } = this.props.match;
    // console.log('params: ', params);
    if (params.actionid == 2 || params.actionid == 4) {
      this.setState({
        actionid: params.actionid,
      });
      this.loadRequest();
    } else {
      window.open("/desk", "_self");
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  loadRequest() {
    const { params } = this.props.match;
    const data = {
      request: [{
        requestcode: params.requestcode,
        actionid: params.actionid,
        comment: null,
        controllid: 1,
      }],
    };

    instance.post(`requestcenter/loadrequestbyrequestcode`, data)
    .then((result) => {
      this.setState({ requestDetail: result.data.result[0] || {} }, () => {
        this.closeWindow();
      });
    }).catch((error) => {
      this.setState({
        error: error.response ? error.response.data.error.message : error.message,
      }, () => {
        this.closeWindow();
      });
      // this.props.enqueueSnackbar(
      //   error.response ? error.response.data.error.message : error.message,
      //   { variant: "error" },
      // );
    });
  }

  closeWindow() {
    this.interval = setInterval(() => this.setState({
      time: this.state.time - 1,
    }, () => {
      if (this.state.time == 0) {
        clearInterval(this.interval);
        window.close();
      }
    }), 1000);
  }

  revokeAction() {
    const { params } = this.props.match;
    const data = {
      request: [{
        requestcode: params.requestcode,
        actionid: 3,
        comment: null,
      }],
    };
    instance.post(`requestcenter/loadrequestbyrequestcode`, data)
    .then(() => {
      window.close();
    })
    .catch((error) => {
      this.props.enqueueSnackbar(
        error.response ? error.response.data.error.message : error.message,
        { variant: "error" },
      );
    });
  }

  render() {
    const { actionid, requestDetail } = this.state;
    let checkvowel = false;
    if (requestDetail && requestDetail.requestmoduleid == 4 && requestDetail.requesttypeid == 1
      && requestDetail.requesteddata && requestDetail.requesteddata.leavetypename) {
      const newleavetype = requestDetail.requesteddata.leavetypename.toLowerCase();
      if (
        newleavetype.charAt(0) == "a"
        || newleavetype.charAt(0) == "e"
        || newleavetype.charAt(0) == "i"
        || newleavetype.charAt(0) == "o"
        || newleavetype.charAt(0) == "h"
        || newleavetype.charAt(0) == "u"
      ) {
        checkvowel = true;
      }
    }
    let fromdate = "";
    if (requestDetail && requestDetail.requestmoduleid == 2 && (requestDetail.requesttypeid == 4 || requestDetail.requesttypeid == 8)) {
      fromdate = `${requestDetail
        && requestDetail.requesteddata
        && get(requestDetail, "requesteddata.fromshiftdate", "")
        && getFormattedDate(get(requestDetail, "requesteddata.fromshiftdate", ""))} - ${get(
          requestDetail,
          "requesteddata.toshiftdate",
          "",
        ) && getFormattedDate(get(requestDetail, "requesteddata.toshiftdate", ""))}`;
    }

    let datedetail = "";
    if (requestDetail && requestDetail.requestmoduleid == 4 && requestDetail.requesttypeid == 1 && requestDetail.requesteddata) {
      const { fromdatetime, todatetime } = requestDetail.requesteddata;
      let { leaveendtypeid, leavestarttypeid } = requestDetail.requesteddata;
      leaveendtypeid = leaveendtypeid == 0 || leaveendtypeid == null ? 1 : leaveendtypeid;
      leavestarttypeid = leavestarttypeid == 0 || leavestarttypeid == null
        ? 1
        : leavestarttypeid;
      if (fromdatetime && todatetime) {
        const from = moment(fromdatetime).format("YYYY-MM-DD");
        const to = moment(todatetime).format("YYYY-MM-DD");

        if (moment(from && from).isSame(to && to, "day")) {
          if (leaveendtypeid && leaveendtypeid == 2) {
            datedetail = `${getFormattedDate(fromdatetime)}[First half]`;
          } else if (leaveendtypeid && leaveendtypeid == 3) {
            datedetail = `${getFormattedDate(fromdatetime)}[Second half]`;
          } else {
            datedetail = getFormattedDate(fromdatetime);
          }
        } else if (
          leaveendtypeid &&
          leaveendtypeid == 1 &&
          leavestarttypeid &&
          leavestarttypeid == 1
        ) {
          datedetail =
            `( ${getFormattedDate(fromdatetime)} ) - ` +
            `( ${getFormattedDate(todatetime)} )`;
        } else if (
          leaveendtypeid &&
          leaveendtypeid == 2 &&
          leavestarttypeid &&
          leavestarttypeid == 3
        ) {
          datedetail =
            `( ${getFormattedDate(fromdatetime)}[Second half]` +
            ` ) - ` +
            `( ${getFormattedDate(todatetime)}[First half]` +
            ` )`;
        } else if (
          leaveendtypeid &&
          leaveendtypeid == 1 &&
          leavestarttypeid &&
          leavestarttypeid == 3
        ) {
          datedetail =
            `( ${getFormattedDate(fromdatetime)}[Second half]` +
            ` ) - ` +
            `( ${getFormattedDate(todatetime)} )`;
        } else if (
          leaveendtypeid &&
          leaveendtypeid == 2 &&
          leavestarttypeid &&
          leavestarttypeid == 1
        ) {
          datedetail =
            `( ${getFormattedDate(fromdatetime)} ) - ` +
            `( ${getFormattedDate(todatetime)}[First half]` +
            ` )`;
        } else if (
          leaveendtypeid &&
          leaveendtypeid == 3 &&
          leavestarttypeid &&
          leavestarttypeid == 2
        ) {
          datedetail =
            `( ${getFormattedDate(fromdatetime)}[First half]` +
            ` ) - ` +
            `( ${getFormattedDate(todatetime)}[Second half]` +
            ` )`;
        }
      }
    }

    return (
      <div className="innerwrapper-full-width">
        <div className="content-outer-wrapper">
          <div style={{ width: 400, margin: "0 auto" }}>
            <Grid container style={{ flexDirection: "column" }}>
              <Grid item md={12} sm={12}>
                <img src={illustration} className="margin-bottom-16"></img>
                <Paper className="padding16 requestview">
                  <Grid container className="display-block">
                    {!this.state.error
                    && <Grid item xs={12} md={12} sm={12}>
                      <p
                        className="headline-h3 margin-bottom-8 margin-top-0"
                        style={{ color: actionid == 2 ? "#18aca7" : "#ff4052" }}
                      >
                        Request {actionid == 2 ? "Accepted" : "Rejected"}
                      </p>
                      <p className="text-align-right extra-small-dark-secondary margin-bottom-8">
                        {getFormattedDate(requestDetail.reqaddeddate)}
                      </p>
                    </Grid>}
                    {this.state.error
                    && <Grid item xs={12} md={12} sm={12}>
                       <p
                        className="headline-h3 margin-bottom-8 margin-top-0"
                        style={{ color: "#ff4052" }}
                      >
                        {this.state.error}
                      </p>
                    </Grid>}
                    {!this.state.error
                    && <Grid item xs={12} md={12} sm={12}>
                      <div className="display-flex">
                        <div className="margin-right-16">
                          <img
                            className="request-center-profile-img-large"
                            src={requestDetail && getFormattedImageLink(requestDetail.imagepath)}
                            height="32"
                          />
                        </div>
                        <div>
                          {requestDetail && requestDetail.senderid == requestDetail.employeeid && (
                            <div>
                              <p className="normal-dark-secondary margin-bottom-8">
                                <strong className="normal-dark">{`${requestDetail.employeename} `}</strong>
                                  has applied {requestDetail.requestmoduleid == 4 && requestDetail.requesttypeid == 1 ? checkvowel ? " an " : " a " : "a"}{" "}{getRequestType(requestDetail)} request
                              </p>
                            </div>
                          )}
                          {requestDetail && requestDetail.senderid != requestDetail.employeeid && (
                            <div>
                              <p className="normal-dark-secondary margin-bottom-8">
                                <strong className="normal-dark">{`${requestDetail.sendername} `}</strong>
                                has applied {requestDetail.requestmoduleid == 4 && requestDetail.requesttypeid == 1 ? checkvowel ? " an " : " a " : "a"}{" "}{`${getRequestType(requestDetail)} request for ${requestDetail.employeename}`}
                              </p>
                            </div>
                          )}
                          {requestDetail && requestDetail.requestmoduleid == 2 && (requestDetail.requesttypeid == 1
                          || requestDetail.requesttypeid == 2 || requestDetail.requesttypeid == 3)
                          && <div>
                            <p className="normal-dark-secondary margin-bottom-8">
                              <strong className="normal-dark">Date: </strong>
                              {getFormattedDate(
                                requestDetail.requesteddata
                                && requestDetail.requesteddata.shiftdate,
                              )}
                            </p>
                          </div>}
                          {requestDetail && requestDetail.requestmoduleid == 2 && (requestDetail.requesttypeid == 4
                          || requestDetail.requesttypeid == 8) && <div>
                            <p className="normal-dark-secondary margin-bottom-8">
                              <strong className="normal-dark">Date: </strong>
                              {`${fromdate}`}
                            </p>
                          </div>}
                          {requestDetail && requestDetail.requestmoduleid == 2 && requestDetail.requesttypeid == 2
                          && <div>
                            <div>
                              <strong>Clock In: </strong>
                              {requestDetail.requesteddata
                              && requestDetail.requesteddata.intime
                              && getTime(requestDetail.requesteddata.intime)}
                            </div>
                          </div>}
                          {requestDetail && requestDetail.requestmoduleid == 2 && (requestDetail.requesttypeid == 2
                          || requestDetail.requesttypeid == 4
                          || requestDetail.requesttypeid == 8)
                          && <p className="normal-dark-secondary margin-bottom-8">
                            <strong className="normal-dark">
                              Location:{" "}
                            </strong>
                            {requestDetail.requesteddata
                            && requestDetail.requesteddata.workrequesttypename
                            && requestDetail.requesteddata.workrequesttypename}
                          </p>}

                          {requestDetail &&requestDetail.requestmoduleid == 4 && requestDetail.requesttypeid == 1 && (
                            <div>
                              <p className="normal-dark-secondary margin-bottom-8">
                                <strong className="normal-dark">Date: </strong>
                                {requestDetail &&
                                requestDetail.requesteddata &&
                                requestDetail.requesteddata.leavetypeid == 3 ? (
                                  <span>
                                    {getFormattedDate(
                                      requestDetail.requesteddata.fromdatetime,
                                    )}
                                    <div>
                                      <strong>From :</strong>{" "}
                                      {getFormattedTimeFromDate(
                                        requestDetail.requesteddata.fromdatetime,
                                      )}
                                    </div>
                                    <div>
                                      <strong>To :</strong>
                                      {getFormattedTimeFromDate(
                                        requestDetail.requesteddata.todatetime,
                                      )}
                                    </div>
                                  </span>
                                ) : (
                                  datedetail
                                )}
                              </p>

                              <p className="normal-dark-secondary margin-bottom-8">
                                <strong className="normal-dark">
                                  Duration:{" "}
                                </strong>
                                {requestDetail &&
                                requestDetail.requesteddata &&
                                requestDetail.requesteddata.leavetypeid != 3
                                ? `${requestDetail.requesteddata.totaldaycount} ${
                                requestDetail.requesteddata.totaldaycount > 1
                                  ? "days"
                                  : "day"
                                } `
                                : `${requestDetail.requesteddata && requestDetail.requesteddata.totaltime} hours`}
                              </p>

                              {requestDetail.requesteddata
                              && requestDetail.requesteddata.subrequesttypename
                              && <div>
                                <Chip label={requestDetail.requesteddata.subrequesttypename} />
                              </div>}
                            </div>
                          )}

                          {requestDetail && requestDetail.requestmoduleid == 4 && requestDetail.requesttypeid == 2
                          && (<div>
                              <div style={{ margin: "16px 0px" }}>
                                {requestDetail
                                && requestDetail.requesteddata
                                && requestDetail.requesteddata.deleteholiday
                                && requestDetail.requesteddata.deleteholiday.length > 0 && (
                                <div>
                                  <div>Holidays removed</div>
                                  <div style={{ margin: "8px 0px" }}>
                                    {requestDetail
                                    && requestDetail.requesteddata
                                    && requestDetail.requesteddata.deleteholiday
                                    && requestDetail.requesteddata.deleteholiday.map((holiday) => (
                                      <div>
                                        <div className="floatleft">
                                          <span>
                                            {holiday.holidaydate
                                            && getFormattedDate(moment(holiday.holidaydate))}
                                          </span>
                                        </div>
                                        <div style={{ float: "right" }}>
                                          <span>
                                            <strong>{holiday.holidayname}</strong>
                                          </span>
                                        </div>
                                        <div style={{ clear: "both" }} />
                                    </div>))}
                                  </div>
                                </div>)}

                                {requestDetail
                                && requestDetail.requesteddata
                                && requestDetail.requesteddata.addedholiday
                                && requestDetail.requesteddata.addedholiday.length > 0 && (
                                <div>
                                  <div>Holidays added</div>
                                  <div style={{ margin: "8px 0px" }}>
                                    {requestDetail
                                    && requestDetail.requesteddata
                                    && requestDetail.requesteddata.addedholiday
                                    && requestDetail.requesteddata.addedholiday.map((holiday) => (
                                      <div>
                                        <div className="floatleft">
                                          <span>
                                            {holiday.holidaydate
                                            && getFormattedDate(moment(holiday.holidaydate))}
                                          </span>
                                        </div>
                                        <div style={{ float: "right" }}>
                                          <span>
                                            <strong>{holiday.holidayname}</strong>
                                          </span>
                                        </div>
                                        <div style={{ clear: "both" }} />
                                    </div>))}
                                  </div>
                                </div>)}
                              </div>
                            </div>
                          )}

                          <div
                            style={{
                              display: "table",
                              padding: 8,
                              margin: "16px 0",
                              background: "#edf5fd",
                            }}
                          >
                            <strong>Message: </strong>{requestDetail && requestDetail.comment}
                          </div>

                          <p className="large-text-dark-secondary margin-top-24 t-bold">
                            Closing this page in {this.state.time} seconds
                          </p>

                          {actionid == 2
                          && <Button
                            className="btn btn-secondary-md-yellow margin-top-24"
                            onClick={this.revokeAction}
                          >
                            Click here to revoke this action
                          </Button>}
                        </div>
                      </div>
                    </Grid>}
                    {this.state.error
                    && <Grid item xs={12} md={12} sm={12}>
                      <p className="large-text-dark-secondary margin-top-24 t-bold">
                        Closing this page in {this.state.time} seconds
                      </p>
                    </Grid>}
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(DialyRequest)));
